import { RootState } from "../../store";
import { ProviderType } from "../../../services/cloudchipr.api";

export const providerSelector = (state: RootState): ProviderType =>
  state.accountSetup.provider;
